import { makeStyles, Theme } from '@material-ui/core/styles';
const styles = makeStyles(({ breakpoints,spacing, palette, typography, variables, schema }: Theme) => ({
    JetAccordionTitle: {
    },
    JetAccordionTitleDefault: {
        color: palette.jet?.contentDefault
    },
    JetAccordionIcon: {
        color: palette.jet?.contentDefault
    },
    JetAccordion: {
        [breakpoints.down('md')]: {
            width:'100% !important'
        },
        border:`2px solid ${palette?.jet?.containerSubtle}`,
        backgroundColor:palette?.jet?.containerSubtle,
        marginBottom: variables?.spacingB,
        cursor:'pointer',
        boxShadow:'0px 0px 0px 0px #fff',
        '&::before':{
            backgroundColor:'unset'
        },

        '&.MuiAccordion-root': {
            borderRadius:`${variables?.radiusRoundedB} !important`,
            '&:before': {
                display:'none !important'
            }
        },
        '&.Mui-expanded': {
            marginTop: '0px !important',
            marginBottom: variables?.spacingB,
            backgroundColor:palette?.jet?.containerDefault,
            border:`2px solid ${palette?.jet?.contentBrand}`,
            boxSizing: 'border-box'
        },
        '& .MuiTouchRipple-root': {
            display: 'none',
        },
        '& .MuiAccordionSummary-content.Mui-expanded': {
            marginTop:`${variables?.spacingC} !important`,
           
        },
        '& .MuiAccordionSummary-root':{
            minHeight:'unset !important',
            '&.Mui-expanded': {
                boxSizing: 'border-box',
                borderBottom:`1px solid ${palette?.jet?.containerSubtle}`
            }
        },
        '& .MuiAccordionDetails-root':{
            whiteSpace:'pre-line'
        },
        '& .MuiCollapse-wrapperInner':{
            marginTop:`${variables?.spacingC}`
        }
    }
}))


export default styles;